import React, {useEffect, useState} from 'react';
import { UserRoleType } from '../../../../constants/types';
import { priceCurrencyToString } from '../../../../constants/payment';
import {
  BUY_SUBSCRIPTION_NOW_MSG,
  CANCEL_SUBSCRIPTION_MSG,
  CHANGE_PAYMENT_METHOD_MSG,
  RENEW_SUBSCRIPTION_MSG,
} from '../../../../constants/localization';
import { compose, defaultProps, withHandlers, withState } from 'recompose';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@material-ui/core';
import Button from '../../../../components/Button';
import Check from '@material-ui/icons/Check';
import PaymentModal from '../../../../components/Modals/Payment';
import { INDEX_ROUTE_BY_ROLE } from '../../../../constants/routes';
import Separator from '../../../../components/Separator';
import { isAndroid } from 'react-device-detect';
import { MOBILE_LINK } from '../../LnMenHealth/constants';
import { useQuery } from 'react-apollo';
import { GET_USER_FREE_TRIAL_DETAILS, UNIVERSAL_USER_QUERY } from 'constants/gql/me';
import Loading from 'components/Loading';
import { USER_ACCESS } from 'constants/gql/payment';

export const StyledCheck = styled(Check)`
  color: ${(props) => props.theme.colors.pictonGrey};
  margin-top: -2px;
  margin-right: 3px;
`;

export const StyledCardActions = styled(CardActions)`
  justify-content: space-around;
`;

export const StyledCard = styled(Card)`
  margin: 10px 10px;
  max-width: 300px;
  transition: 0.2s;
  cursor: grabbing;
  min-width: 185px;
  min-height: 355px;
  @media (max-width: 1366px) {
    min-height: 394px;
  }
`;

export const Header = styled(CardHeader)<{ isLabeledPlan: boolean }>`
  & .MuiTypography-h5 {
    padding-top: ${(props) => (props.isLabeledPlan ? '0px' : '21px')};
    font-size: 1.9rem;
    font-weight: 500;
    text-align: center;
    color: dimgrey;

    @media (max-width: 1366px) {
      font-size: 1.7rem;
    }

    @media (max-width: 1112px) {
      font-size: 1.5rem;
    }

    @media (max-width: 1024px) {
      font-size: 1.3rem;
    }
  }
`;

export const PlanNameWrapper = styled.div`
  & .MuiTypography-h6 {
    @media (max-width: 1024px) {
      font-size: 0.9rem;
    }
  }
`;

const PlanDescription = styled.div`
  padding: 10px 0;
  font-size: 0.8rem;
`;

export const SubscriptionState = styled.div<{
  isLabeledPlan: boolean;
  isChooseDisabled: boolean;
  isActivePlan: boolean;
  isRenewableSubscription: boolean;
}>`
  text-align: center;
  & .MuiTypography-subtitle2 {
    display: inline;
    background: ${(props) =>
      props.isRenewableSubscription
        ? 'red'
        : props.isActivePlan
        ? props.theme.colors.green
        : props.isChooseDisabled
        ? 'lightgray'
        : '#57bbc8'};
    color: white;
    padding-inline-start: ${(props) => (props.isLabeledPlan ? '1em' : '0')};
    padding-inline-end: ${(props) => (props.isLabeledPlan ? '1em' : '0')};
    border-radius: 10px;
  }
`;

export const ChoosePlanButton = styled(Button)<{
  isLabeledPlan: boolean;
  isCanceledSubscription: boolean;
  disabled: boolean;
}>`
  background: white;
  border-style: solid;
  border-color: ${(props) => (props.disabled ? 'lightgray' : '#57bbc8')};
  color: ${(props) => (props.disabled ? 'lightgray' : '#57bbc8')};
  &:hover {
    color: ${(props) => (props.disabled ? 'lightgray' : 'white')};
    background: ${(props) => (props.disabled ? 'white' : '#57bbc8')};
  }
`;

export const YetAnotherPlanButton = styled(Button)<{ disabled: boolean }>`
  background: white;
  border-style: solid;
  border-color: ${(props) => (props.disabled ? 'lightgray' : '#57bbc8')};
  color: ${(props) => (props.disabled ? 'lightgray' : '#57bbc8')};
  &:hover {
    color: ${(props) => (props.disabled ? 'lightgray' : 'white')};
    background: ${(props) => (props.disabled ? 'white' : '#57bbc8')};
  }
`;


export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  align-items: flex-start;
`;

export const DescriptionRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 195px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const PricingPlan: React.FunctionComponent<IProps> = ({
  planId,
  price,
  currency,
  header,
  description,
  isLabeled,
  label,
  chooseDisabled,
  isActivePlan,
  isPendingPlan,
  isRenewableSubscription,
  isPaymentMethodChangeable,
  isCancelable,
  isIOSSubscription,
  successfullyPaymentRedirect,
  role,
  isPaymentModalOpen,
  setPaymentModalOpen,
  choosePaymentPlan,
  switchAnotherPlan,
  maxPatients,
  switchMessage,
  openChangePaymentMethodModal,
  openConfirmCancelSubModal
}) => {
  const [isFreeTrial, setIsFreeTrial] = useState(false);
  const [freeTrialTillDate, setFreeTrialTillDate] = useState(null);
  const [userAccess, setUserAccess] = useState(null);

  const { data: freeTrialData, loading: freeTrialLoading, error: freeTrialError, refetch } = useQuery(GET_USER_FREE_TRIAL_DETAILS, {
    fetchPolicy: 'network-only',
  });

  if (freeTrialError) {
    console.log('Free trial error');
    console.log(freeTrialError);
  }

  useEffect(() => {
    refetch()?.then((res) => {
      console.log(`Refetched: ${JSON.stringify(res.data)}`)
    }).catch((err) => {
      console.log(`Failed to refetch: ${JSON.stringify(err)}`);
    });
  }, [refetch]);

  useEffect(() => {
    if (!freeTrialLoading && freeTrialData?.profile) {
      setIsFreeTrial(freeTrialData.profile.isManualSubscribed);
      setFreeTrialTillDate(freeTrialData.profile.manualSubscribedTillDate);
    }
  }, [freeTrialLoading, freeTrialData]);

  const { data: userAccessData, loading: userAccessLoading, error: userAccessError } = useQuery(USER_ACCESS, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!userAccessLoading && userAccessData?.getUserAccess) {
      setUserAccess(userAccessData.getUserAccess);
    }
  }, [userAccessLoading, userAccessData]);

  if (freeTrialLoading || userAccessLoading) {
    return <Loading />;
  }

  const isDoctorSubscriptionActive = userAccess?.underDoctorSubscription?.isActive;
  const isClinicSubscriptionActive = userAccess?.underClinicSubscription?.isActive;
  const disableSubscriptionActions = isFreeTrial || isDoctorSubscriptionActive || isClinicSubscriptionActive;

  return (
    <>
      <StyledCard>
        {isLabeled && (
          <SubscriptionState
            isLabeledPlan={isLabeled}
            isChooseDisabled={chooseDisabled}
            isRenewableSubscription={isRenewableSubscription}
            isActivePlan={isActivePlan}
          >
            <Typography variant="subtitle2">{label}</Typography>
          </SubscriptionState>
        )}
        <Header
          isLabeledPlan={isLabeled}
          title={`${priceCurrencyToString(price, currency)}/mo`}
        />
        <Divider variant="middle" />
        <CardContent>
          <PlanNameWrapper>
            <Typography variant="h6" align="center">
              {header}
            </Typography>
          </PlanNameWrapper>
          <DescriptionContainer>
            {role === 'PATIENT' && (
              <PlanDescription>
                MenHealth mobile uroflow app captures vital data that enables
                early diagnostics, and empowers patients to self-assess, be more
                aware, and have more control of their urinary health. MenHealth® 
                “listens” to the sound of urine when it hits the water surface in
                a toilet and calculates all the urine flow parameters{' '}
              </PlanDescription>
            )}
            {description.map((descriptionString: string) => (
              <DescriptionRowWrapper>
                <StyledCheck />
                <Typography
                  variant="body2"
                  align="left"
                  style={{
                    minWidth: '195px',
                  }}
                >
                  {descriptionString}
                </Typography>
              </DescriptionRowWrapper>
            ))}
          </DescriptionContainer>
        </CardContent>
        <Divider variant="middle" />
        <StyledCardActions>
          <ButtonsWrapper>
            {/*can only renew patient subscription*/}
            {!isActivePlan &&
              !isIOSSubscription &&
              (!isRenewableSubscription || role === 'PATIENT') && (
                <ChoosePlanButton
                  disabled={disableSubscriptionActions}
                  isLabeledPlan={isLabeled}
                  isCanceledSubscription={isRenewableSubscription}
                  onClick={() => {
                    choosePaymentPlan();
                  }}
                >
                  {isRenewableSubscription
                    ? RENEW_SUBSCRIPTION_MSG
                    : BUY_SUBSCRIPTION_NOW_MSG}
                </ChoosePlanButton>
              )}
            <Separator />
            {switchAnotherPlan && !isIOSSubscription && (
              <YetAnotherPlanButton
                onClick={() => {
                  switchAnotherPlan();
                }}
                disabled={disableSubscriptionActions}
              >
                {switchMessage}
              </YetAnotherPlanButton>
            )}
            {isCancelable && !isIOSSubscription && (
              <YetAnotherPlanButton onClick={openConfirmCancelSubModal} disabled={disableSubscriptionActions}>
                {CANCEL_SUBSCRIPTION_MSG}
              </YetAnotherPlanButton>
            )}
            <Separator />
            {isPaymentMethodChangeable && !isIOSSubscription && (
              <YetAnotherPlanButton onClick={openChangePaymentMethodModal} disabled={disableSubscriptionActions}>
                {CHANGE_PAYMENT_METHOD_MSG}
              </YetAnotherPlanButton>
            )}
          </ButtonsWrapper>
        </StyledCardActions>
      </StyledCard>
      <PaymentModal
        isModalOpen={isPaymentModalOpen}
        toggleModal={setPaymentModalOpen}
        planId={planId}
        price={price}
        maxPatients={maxPatients}
        header={header}
        currency={currency}
        isPatient={role === 'PATIENT'}
        successfullyPaymentRedirect={successfullyPaymentRedirect}
        hasActivePlan={isActivePlan}
        isRenewedSubscription={isRenewableSubscription}
        isPendingSubscription={isPendingPlan}
      />
    </>
  );
}

export default compose<IInnerProps, IOuterProps>(
  withRouter,
  withState('isPaymentModalOpen', 'setPaymentModalOpen', false),
  withHandlers({
    choosePaymentPlan:
      ({ setPaymentModalOpen }: IProps) =>
      () => {
        setPaymentModalOpen(true);
      },
    successfullyPaymentRedirect:
      ({ history, role }: IProps) =>
      () => {
        history.replace(INDEX_ROUTE_BY_ROLE(role));

        //The redirect is relevant for Android only. Because for the iOS we have in-app purchases.
        if (isAndroid && role === 'PATIENT') {
          const mobileAppLinkURL: URL = new URL(MOBILE_LINK);
          window.open(mobileAppLinkURL.href, '_self');
        }
      },
  }),
)(PricingPlan);

type IProps = IInnerProps & IOuterProps & RouteComponentProps;

interface IInnerProps {
  isPaymentModalOpen: boolean;
  setPaymentModalOpen: (value: boolean) => void;
  successfullyPaymentRedirect: () => void;
  choosePaymentPlan: () => void;
}

interface IOuterProps {
  role: UserRoleType;
  currency: string;
  planId: string;
  price: string;
  header: string;
  description: string[];
  isLabeled: boolean;
  label: string;
  chooseDisabled: boolean;
  isActivePlan: boolean;
  isPendingPlan: boolean;
  isCancelable: boolean;
  isPaymentMethodChangeable: boolean;
  isRenewableSubscription: boolean;
  isIOSSubscription: boolean;
  maxPatients: number;
  switchAnotherPlan: () => void;
  switchMessage: string;
  openConfirmCancelSubModal: (event: React.SyntheticEvent<any, Event>) => void;
  openChangePaymentMethodModal: (
    event: React.SyntheticEvent<any, Event>,
  ) => void;
  isManualSubscribed: boolean;
  manualSubscribedTillDate: Date | null;
}
